import { active_perm } from '../../activeVM.js';
import { vm_cache } from './WebconnectFrame.js';
import { toast } from '../Toast.js'
import { logEvent } from '../../log';

export const listen_iframe_close = (iframe, perm_id) => {
  const started = Date.now();
  let reported = false;
  const listener = window.setInterval(() => {

    // Stop polling once this connection's iframe has been removed from the DOM.
    if (!iframe.isConnected) {
      clearInterval(listener);
      return;
    }

    // This only works when the iframe is same-origin. If the connection fails to initialize the guacamole extension,
    // we cannot recognize disconnections.
    const $ = iframe.contentWindow && iframe.contentWindow.$;
    if (typeof $ === 'function') {
      const guacamoleLoginPage = $('.login-ui:not(.ng-hide)').length;
      const disconnectedDialog = $('.title:contains("Disconnected")').length;
      const errorDialog = $('.error').length;

      if (guacamoleLoginPage || disconnectedDialog || errorDialog) {
        if (!reported) {
          reported = true;
          logEvent('connection.session.disconnected', {
            connection_type: 'webconnect',
            reason: guacamoleLoginPage ? 'login_page' : errorDialog ? 'error' : 'disconnected',
            duration_ms: Date.now() - started,
            perm_id: /^\d+$/.test(perm_id) ? Number(perm_id) : undefined,
          });
        }
        const errorElement = $('.error')?.[0];

        if (errorElement) {
          const errorMessage = (
              errorElement.getElementsByClassName("error-text")?.[0]?.innerText ||
              errorElement.getElementsByClassName("text")?.[0]?.innerText
          );

          if (errorMessage) {
            toast.error({ text: errorMessage, hideAfter: 7000 });
            clearInterval(listener);
          }
        }

        // if selected
        if (active_perm.get() === perm_id) {
          active_perm.set();
        }
        vm_cache.delete(perm_id);
      }
    }
  }, 250);
};

